import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import { ClosePulseSurveyParams, ClosePulseSurveyResponse } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { closePulseSurvey } from 'api/actions/pulseSurveys/pulseSurveysActions'

export const useCloseSurvey = () => {
    const queryClient = useQueryClient()

    const mutation = useMutation<ClosePulseSurveyResponse, AxiosError, ClosePulseSurveyParams>({
        mutationFn: closePulseSurvey,
        mutationKey: [Mutations.closePulseSurvey],
        onSuccess: async ({ uuid }) => {
            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            await queryClient.invalidateQueries([Queries.getPulseSurveyDetail, { surveyUUID: uuid }])
        },
    })

    return mutation
}
